/*=========================================================================================
  File Name: moduleSocieteState.js
  Description: Societe Module State
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  societes: []
}
